import React from 'react';
import { AlertConfigContext } from '../providers';
export function useAlertConfig() {
    return React.useContext(AlertConfigContext);
}
